import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProfileMenu from './ProfileMenu.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMobileDrawer',
  props: {
  open: {
    type: Boolean,
    required: true,
  },
  isAuthenticated: {
    type: Boolean,
    default: false,
  },
  userName: {
    type: String,
    default: '',
  },
  userEmail: {
    type: String,
    default: '',
  },
  scrim: {
    type: [Boolean, String],
    default: true,
  },
},
  emits: ["update:open", "navigate", "logout"],
  setup(__props) {

/* eslint-disable */





return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    class: "header-mobile-dialog",
    "model-value": __props.open,
    scrim: __props.scrim,
    "content-class": "header-mobile-dialog__content",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(ProfileMenu)
    ]),
    _: 1
  }, 8, ["model-value", "scrim"]))
}
}

})